import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { DateTagComponent } from '../date-tag/date-tag.component'

@Component({
  selector: 'alert',
  imports: [DateTagComponent],
  standalone: true,
  templateUrl: './alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  visible = input.required<boolean>()
  headetText = input.required<string>()
  title = input.required<string>()
  description = input.required<string>()
  image = input.required<string>()
  buttonText = input.required<string>()
  secondaryButton = input(false)

  primaryClicked = output<void>()
  secondaryClicked = output<void>()

  onPrimaryClick() {
    this.primaryClicked.emit()
  }

  onSecondaryClick() {
    this.secondaryClicked.emit()
  }
}
